/**
 * PORTED — RO-3-03 / #44296.
 * Origin: `excellent/app/work/_chat/work-chat-stage-launcher.tsx`.
 *
 * Dispatches the same `excellent:open-stage` custom event StageHost
 * listens for (StageProvider in the root shell). Chat pane is a stub until
 * Rooms/ChatSurface is ported; the event still opens a Stage tab.
 */

import { useEffect } from "react";
import { Button } from "@excellent/ui";

const OPEN_STAGE_EVENT = "excellent:open-stage";

type OpenStageDetail = {
  kind: string;
  slug: string;
  name: string;
};

function openChatStage() {
  const detail: OpenStageDetail = {
    kind: "chat",
    slug: "chat",
    name: "Chat",
  };
  window.dispatchEvent(new CustomEvent(OPEN_STAGE_EVENT, { detail }));
}

export function WorkChatStageLauncher() {
  useEffect(() => {
    openChatStage();
  }, []);

  return (
    <div className="flex flex-col items-center justify-center gap-2 p-12 text-center">
      <p className="type-body text-muted-foreground">
        Chat is open in the Stage. Use the Stage tab bar to switch tabs, or minimize to
        return here.
      </p>
      <Button type="button" variant="link" size="sm" onClick={openChatStage}>
        Re-open Chat Stage
      </Button>
    </div>
  );
}
